 
import { useNavigate } from "react-router-dom";
import "../styles/BookingSuccessModal.css"; // We'll create this CSS file next

const BookingSuccessModal = ({ isOpen, onClose,fetchBookings,editMode }) => {
  const navigate = useNavigate();

  // Go back to home page
  const goToHome = () => {
    navigate("/");
    if (onClose) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
         {/* Close button (X) in the top right corner 
         <button 
          className="close-button"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>*/}
        <div className="success-icon">
          <div className="check-circle">
            <i className="fas fa-check"></i>
          </div>
        </div>
        <h2 className="thank-you-heading">Thank you!</h2>
        { editMode ? (
          <p className="success-message">Your guest house details are successfully updated</p>
        ) : (
          <p className="success-message">Your guest house is successfully booked</p>
        )} 
       
        <button 
          className="go-home-button"
          onClick={onClose}
        >
         OK
        </button>
      </div>
    </div>
  );
};

export default BookingSuccessModal;